import { io } from 'socket.io-client';
import { getApiBaseUrl } from './apiBaseUrl';

let socket = null;

export function getSocket() {
	if (!socket) {
		socket = io(getApiBaseUrl(), {
			transports: ['websocket', 'polling'],
			autoConnect: true,
			reconnectionAttempts: 5,
			reconnectionDelay: 2000,
		});
	}
	return socket;
}
